// Packages
import htmr from 'htmr'

// Components
import { Flex, Text } from 'yard-utilities/components'

// Styles
import styles from './TextReviewCard.module.sass'

interface ReviewProps {
  name: string
  quote: string
  message: string
  memberSince: number
}

const TextReviewCard = ({ name, quote, message, memberSince }: ReviewProps) => {
  return (
    <Flex flexDirection="column" center style={{ marginInline: '-1rem' }}>
      <Text tagName="h3" variant="title-5" align="center" spacing={{ sm: 16 }}>
        {quote}
      </Text>
      <Text
        tagName="p"
        variant="body-1"
        align="center"
        spacing={{ sm: 16 }}
        className={styles.message}
      >
        {htmr(message)}
      </Text>
      <Text
        tagName="p"
        variant="body-1"
        align="center"
        fontWeight={600}
        spacing={{ sm: 4 }}
      >
        {name}
      </Text>
      <Text tagName="p" variant="body-6" align="center" textColor="grey-2">
        Member since {memberSince}
      </Text>
    </Flex>
  )
}

export default TextReviewCard
